var base = window.base;
var base;
window.Aedu || (window.Aedu = {});
(base = window.Aedu).Behaviors || (base.Behaviors = {});
window.base = base;